import {Inject, LOCALE_ID, Pipe, PipeTransform} from '@angular/core';
import {formatNumber} from '@angular/common';

@Pipe({
    name: 'powerInWToKw'
})
export class PowerInWToKwPipe implements PipeTransform {

    constructor(@Inject(LOCALE_ID) private readonly locale: string) {
    }

    /**
     *
     * @param powerInW The number to be formatted
     * @param digitsInfo Decimal representation options, specified by a string in the following format:
     * <code>{minIntegerDigits}.{minFractionDigits}-{maxFractionDigits}</code>
     * <ul>
     *     <li>minIntegerDigits: The minimum number of integer digits before the decimal point. Default is 1.</li>
     *     <li>minFractionDigits: The minimum number of digits after the decimal point. Default is 0.</li>
     *     <li>maxFractionDigits: The maximum number of digits after the decimal point. Default is 3.</li>
     * </ul>
     * From Angular DecimalPipe. Optional. Default is undefined.
     * @param displayUnit True to display 'kW' unit after value, false otherwise
     */
    transform(powerInW: number, digitsInfo?: string, displayUnit: boolean = true): string {
        let powerInKw = '';

        if (!powerInW) {
            powerInKw = '0';
        } else {
            powerInKw = formatNumber(powerInW / 1000, this.locale, digitsInfo);
        }

        if (displayUnit) {
            powerInKw += ' kW';
        }

        return powerInKw;
    }
}
